// extracted by mini-css-extract-plugin
export default {"main-container":"TriggerCell_main-container__GpZSM"};